import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { LabelService } from '../../services/label.service';
import { PatientNote } from '../../models/patient-model';
import { PatientService } from '../../services/patient.service';
import { Subject, takeUntil } from 'rxjs';
import { ErrorPanelService } from '../../services/error-panel.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationPanelComponent } from '../confirmation-panel/confirmation-panel.component';

@Component({
  selector: 'app-patient-notes',
  standalone: false,
  templateUrl: './patient-notes.component.html',
  styleUrl: './patient-notes.component.scss',
})
export class PatientNotesComponent {
  @Input() patientId: string = '';
  @Input() isMobile: boolean = false;
  @Input() notes: PatientNote[] = [];
  @Output() switchPanels = new EventEmitter<void>();
  @Output() changesInNotes = new EventEmitter<void>();

  isDeleteNotesEnabled: boolean = false;
  showAddNotePanel: boolean = false;
  showDeleteNotePanel: boolean = false;
  showUpdateNotePanel: boolean = false;

  selectedNote: PatientNote = {
    id: '',
    patientId: '',
    dateLastModified: '',
    description: '',
  };

  constructor(
    public labelService: LabelService,
    private patientService: PatientService,
    public errorPanelService: ErrorPanelService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  switchSectionMobile() {
    this.switchPanels.emit();
  }

  toggleAddNotePanel() {
    this.showAddNotePanel = !this.showAddNotePanel;
  }

  createNewNote(text: string): void {
    const obj = {
      patient_id: this.patientId,
      description: text,
    };
    this.patientService.createNote(obj).subscribe({
      next: (response) => {
        this.showAddNotePanel = !this.showAddNotePanel;
        this.changesInNotes.emit();
      },
      error: (error) => {
        console.error('Qualcosa è andato storto', error);
        this.showAddNotePanel = !this.showAddNotePanel;
        this.errorPanelService.showErrorSnackBar('Errore nel creare la nota');
      },
    });
  }

  // toggleDeleteNotePanel(note?: PatientNote): void {
  //   if (note) {
  //     this.selectedNote = note;
  //   } else {
  //     this.selectedNote = {
  //       id: '',
  //       patientId: '',
  //       dateLastModified: '',
  //       description: '',
  //     };
  //   }
  //   this.showDeleteNotePanel = !this.showDeleteNotePanel;
  // }

  deleteNote(note: PatientNote): void {
    const dialogRef = this.dialog.open(ConfirmationPanelComponent, {
      data: {
        title: 'Sei sicuro di voler eliminare questa nota?',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.patientService.deleteNote(note.id).subscribe({
          next: (response) => {
            this.notes = this.notes.filter(
              (note) => note.id !== this.selectedNote.id
            );
            this.changesInNotes.emit();
          },
          error: (error) => {
            console.error('Qualcosa è andato storto', error);
            this.errorPanelService.showErrorSnackBar(
              "Errore nell'eliminare la nota"
            );
          },
        });
      } else {
        console.log('Eliminazione annullata');
      }
    });
  }

  toggleUpdateNotePanel(note?: PatientNote): void {
    if (note) {
      this.selectedNote = note;
    } else {
      this.selectedNote = {
        id: '',
        patientId: '',
        dateLastModified: '',
        description: '',
      };
    }
    this.showUpdateNotePanel = !this.showUpdateNotePanel;
  }

  updateNote(text: string) {
    this.selectedNote.description = text;
    const obj = {
      patient_id: this.patientId,
      description: text,
    };
    this.patientService.updateNote(this.selectedNote.id, obj).subscribe({
      next: (response) => {
        this.toggleUpdateNotePanel();
        this.changesInNotes.emit();
      },
      error: (error) => {
        console.error('Qualcosa è andato storto', error);
        this.toggleUpdateNotePanel();
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'aggiornare la nota"
        );
      },
    });
  }
}
